export default {
    state: {
        pharmacy: null,
        pharmacyGroup: null,
        isConsolidateModus: false,
        month: 1,
        year: 2018
    },
    mutations: {
        setNavSelection(state, { pharmacy, month, year }) {
            state.pharmacy = pharmacy;
            state.month = month;
            state.year = year;
        },
        setSelectedPharmacy(state, pharmacy) {
            state.pharmacy = pharmacy;
        },
        setSelectedPharmacyGroup(state, pharmacyGroup) {
            state.pharmacyGroup = pharmacyGroup;
        },
        setConsolidateModus(state, ConsolidateModus) {
            state.isConsolidateModus = ConsolidateModus;
        },
        setSelectedMonth(state, month) {
            state.month = month;
        },
        setSelectedYear(state, year) {
            state.year = year;
        }
    }
};
